var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.model.feedback.decisionDate
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.InvestmentReport.DecisionDate",
              bold: true,
              value: _vm._f("formatDate")(_vm.model.feedback.decisionDate, true)
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentUser.organisationName
        ? _c("text-label-row", {
            attrs: {
              title: "OrganisationName",
              bold: true,
              value: _vm.currentUser.organisationName
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentUser.organisationNumber
        ? _c("text-label-row", {
            attrs: {
              title: "Pdf.OrganisationNumber",
              bold: true,
              value: _vm.getNumberAsString(_vm.currentUser.organisationNumber)
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("text-label-row", {
        attrs: {
          title: "Feedback.AidApplication.AidTarget",
          bold: true,
          value: _vm.record.aidTargetNumber
        }
      }),
      _vm._v(" "),
      _vm.model.basicInfo.purpose
        ? _c("text-label-row", {
            attrs: {
              title: "Purpose",
              bold: true,
              value: _vm.model.basicInfo.purpose
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.model.basicInfo.aidTargetDecisionTerms
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.InvestmentReport.AidTargetDecisionTerms",
              bold: true,
              value: _vm.model.basicInfo.aidTargetDecisionTerms
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("granted-amounts-list", {
        attrs: {
          title: "Feedback.InvestmentReport.GrantedAmounts",
          bold: true,
          aidYears: _vm.model.basicInfo.grantedYears
        }
      }),
      _vm._v(" "),
      _c("text-label-row", {
        attrs: {
          title: "Feedback.AidPercent",
          bold: true,
          sign: "%",
          value: _vm.getNumberAsString(_vm.model.basicInfo.aidPercent)
        }
      }),
      _vm._v(" "),
      _vm.decisionStateStr
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.State",
              bold: true,
              value: _vm.decisionStateStr
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("text-label-row", {
        attrs: {
          title: "Feedback.InvestmentReport.ApprovedCosts",
          bold: true,
          formatNumber: true,
          sign: "€",
          value: _vm.getNumberAsString(_vm.model.feedback.approvedCosts)
        }
      }),
      _vm._v(" "),
      _c("text-label-row", {
        attrs: {
          title: "Feedback.InvestmentReport.AidPartOfClearedCosts",
          bold: true,
          formatNumber: true,
          sign: "€",
          value: _vm.getNumberAsString(_vm.model.feedback.aidPartOfClearedCosts)
        }
      }),
      _vm._v(" "),
      _vm.record.feedback
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.InvestmentReport.Feedback",
              bold: true,
              value: _vm.record.feedback
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.model.feedback.introducerNoteOfDissent
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.InvestmentReport.IntroducerNoteOfDissent",
              bold: true,
              value: _vm.model.feedback.introducerNoteOfDissent
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.record.decisionMaker
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.Decision.DecisionMaker",
              bold: true,
              value: _vm.record.decisionMaker.contactInfo
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "mt-5 mb-5",
        domProps: { innerHTML: _vm._s(_vm.$t("rectificationInstructions")) }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }